module.exports = __webpack_public_path__ + "static/media/witnessSelecetd.945bd701.svg";